<template>
  <div :style="'background: ' + cpntBackground + ';'" class="rf-carousel">
    <!-- SETA A MASCARA -->
    <div class="mascara-geral" v-if="statusGeral === 'carregando'" :style="'height: ' + cpntHeight + 'px; padding-top: ' + ((cpntHeight / 2) - (27 / 2)) + 'px;'">
      <RF-Status-2 :cpntStatus='"carregando"' :cpntTamanho='5'></RF-Status-2>
    </div>

    <!-- ADCIONA A MASCARA CARREGANDO -->
    <div class="mascara" v-else-if="statusGeral !== ''" :key="'ven-editar-anexos-bt--' + cpntId">
      <RF-Status-2 :cpntStatus='statusGeral'></RF-Status-2>
    </div>

    <template v-else>
      <label v-show="mostrar === true">
          <span v-html='cpntNome'></span>

          <RF-Explica v-if='[ "", null, undefined ].indexOf(cpntExplica) === -1 && Object.keys(cpntExplica).length >= 1'
            :cpntId='cpntId + "-explica"' 
            :cpntTitle='cpntExplica.mensagem'
            :cpntPositionMy='cpntExplica.posicaoMy'
            :cpntPositionAt='cpntExplica.posicaoAt'
            :cpntClasses='cpntExplica.class'

            style='vertical-align: 0px;'
          ></RF-Explica>
        </label>

      <table v-show="mostrar === true" :style="imagens.length <= 1 ? ('margin: 0px auto; width: ' + cpntWidth + 'px; height: ' + cpntHeight + 'px;') : ''">
        <tr>  
          <td :style="'width: ' + cpntWidth + 'px; height: ' + cpntHeight + 'px;'">
            <b-carousel class="carousel noselect" :style="'width: ' + cpntWidth + 'px; height: ' + cpntHeight + 'px;'"
              :id="cpntId"
              v-model="slide"
              :interval="cpntTempo"
              no-hover-pause
              fade
              controls
              :indicators="cpntIndicadores"
              :background="cpntBackground"
              :img-width="cpntWidth"
              :img-height="cpntHeight"
            >
              <!-- SETA A IMAGEM DE NENHUM REGISTRO ENCONTRADO -->
              <template v-if="imagens.length === 0">
                <b-carousel-slide class="noselect">
                  <template v-slot:img>
                    <img src="./sem_imagem.png" class="noselect" style="width: 1px; height: 1px;" ref="carousel" @load="cpntCarouselCalcularTamanho(0, 'carousel')" />
                  </template>
                </b-carousel-slide>
              </template>

              <!-- SETA A IMAGEM QUE DEVE SER APRESENTADA -->
              <template v-if="imagens.length >= 1">
                <b-carousel-slide v-for="(imagem, indexI) in imagens" :data-time="time" :key="'img--' + indexI" class="noselect">
                  <template v-slot:img>
                    <img :src="imagem.src" class="noselect" style="width: 1px; height: 1px;" ref="carousel" @click="cpntCarouselMostrarLightbox(indexI)" @load="cpntCarouselCalcularTamanho(indexI, 'carousel')">
                  </template>
                </b-carousel-slide>
              </template>
            </b-carousel>
          </td>
          <td class="miniatura" v-if="imagens.length >= 2">
            <div :style="'height: ' + cpntHeight + 'px;'">
              <div v-for="(imagem, indexL) in imagens" :data-time="time" :key="'tr-image--' + indexL" :class="slide === indexL ? 'selected' : ''">
                <img :src="imagem.src" class="noselect" style="width: 1px; height: 1px;" ref="mini" @load="cpntCarouselCalcularTamanho(indexL, 'mini')" @click="slide = indexL" >
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="[ '', null, undefined ].indexOf(buttons) === -1">
          <td colspan="2" class="botoes">
            <div>
              <RF-Button v-for="(button, index) in buttons" :key="index"
                :cpntStatus='button.status' 
                :cpntId='button.id' 
                :cpntTexto='button.texto' 
                :cpntClass='button.class'
                :cpntTabIndex='button.tabIndex'
                :cpntMostrar='button.mostrar === true && ((index !== "editar" || (index === "editar" && imagens.length >= 1) !== false))'

                @onClickButton='button.onClick'
              ></RF-Button>
            </div>
          </td>
        </tr>
      </table>

      <!-- ABRE O COMPONENTE PARA VER A IMAGEM MAIOR -->
      <vue-easy-lightbox
        :visible="lightbox !== ''"
        :imgs="imagens"
        :index="[ '', null, undefined ].indexOf(lightbox) !== -1 ? 0 : Number(lightbox)"
        @hide="() => { cpntCarouselMostrarLightbox('') }"
      ></vue-easy-lightbox>

      <!-- ABRE O COMPONENTE PARA EDITAR AS INFORMAÇOES -->
      <RF-Carousel-Editar v-if="[ '', null, undefined ].indexOf(buttons) === -1 && [ '', null, undefined ].indexOf(buttons.editar) === -1 && buttons.editar.editar === true && imagens.length >= 1"
      :cpntId="cpntId + '--editar'"
      :cpntRefMod="cpntRefMod"
      :cpntRefId="cpntRefId"
      :cpntFecharFormulario="buttons.editar.onClick"
      ></RF-Carousel-Editar>
    </template>
  </div>
</template>

<style scoped>
.rf-carousel {
  padding: 4px;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  margin-bottom: 25px;
  margin-top: 2px;
}
  .rf-carousel > label {
    margin-top: -25px;
  }
  .rf-carousel > table {
    width: 100%;
  }
    .rf-carousel > table > tr > td.botoes > div {
      text-align: center;
      /* position: absolute; */
      /* margin-top: -28px; */
      padding-top: 5px;
    }
      .rf-carousel > table > tr > td.botoes > div > button {
        width: calc(50% - 5px - 5px);
        height: 20px;
        margin: 0px 5px;
        padding: 0px;
      }
    .rf-carousel > table > tr > td > .carousel {
      text-align: center;
      border-radius: 5px;
      vertical-align: middle;
    }
    .rf-carousel > table > tr > td.miniatura {
      padding-left: 1px;
    }
      .rf-carousel > table > tr > td.miniatura > div {
        overflow-y: auto;
        padding-right: 2px;
      }
      .rf-carousel > table > tr > td.miniatura > div::-webkit-scrollbar {
        width: 5px;
      }
        .rf-carousel > table > tr > td.miniatura > div > div {
          margin-top: 3px;
          border-radius: 5px;
          text-align: center;
          background: #e9e9e9;
          padding: 2px;
          border-radius: 5px;
          border: 1px solid #fff;
        }
        .rf-carousel > table > tr > td.miniatura > div > div:hover,
        .rf-carousel > table > tr > td.miniatura > div > div.selected {
          background: #c9c9c9;
          border: 1px solid #ccc;
        }
        .rf-carousel > table > tr > td.miniatura > div > div:first-child {
          margin-top: 0px;
        }
          .rf-carousel > table > tr > td.miniatura > div > div {
            background: #e9e9e9;
          }
</style>

<style>
  .rf-carousel > table > tr > td.miniatura > div > div > img,
  .rf-carousel > table > tr > td > .carousel > div > div > img {
    border-radius: 4px;
    cursor: pointer;
  }

  /* CSS COPIADO DO ARQUIVO DO PLUGIN, PARA NÃO ALTERAR O CSS DO SISTEMA */
  /* LINK DA PASTA: bootstrap-vue/node_modules/bootstrap/dist/css/bootstrap.min.css */
  .carousel {
    position: relative;
  }
  .carousel.pointer-event {
    -ms-touch-action: pan-y;
    touch-action: pan-y;
  }
  .carousel-inner {
    position: relative;
    width: 100%;
    overflow: hidden;
  }
  .carousel-inner::after {
    display: block;
    clear: both;
    content: "";
  }
  .carousel-item {
    position: relative;
    display: none;
    float: left;
    width: 100%;
    margin-right: -100%;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    transition: -webkit-transform 0.6s ease-in-out;
    transition: transform 0.6s ease-in-out;
    transition: transform 0.6s ease-in-out, -webkit-transform 0.6s ease-in-out;
  }
  @media (prefers-reduced-motion: reduce) {
    .carousel-item {
      transition: none;
    }
  }
  .carousel-item.active,
  .carousel-item-next,
  .carousel-item-prev {
    display: block;
  }
  .carousel-item-next:not(.carousel-item-left),
  .active.carousel-item-right {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
  }
  .carousel-item-prev:not(.carousel-item-right),
  .active.carousel-item-left {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
  .carousel-fade .carousel-item {
    opacity: 0;
    transition-property: opacity;
    -webkit-transform: none;
    transform: none;
  }
  .carousel-fade .carousel-item.active,
  .carousel-fade .carousel-item-next.carousel-item-left,
  .carousel-fade .carousel-item-prev.carousel-item-right {
    z-index: 1;
    opacity: 1;
  }
  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-right {
    z-index: 0;
    opacity: 0;
    transition: opacity 0s 0.6s;
  }
  @media (prefers-reduced-motion: reduce) {
    .carousel-fade .active.carousel-item-left,
    .carousel-fade .active.carousel-item-right {
      transition: none;
    }
  }
  .carousel-control-prev,
  .carousel-control-next {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 1;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    justify-content: center;
    width: 15%;
    color: #fff;
    text-align: center;
    opacity: 0.5;
    transition: opacity 0.15s ease;
  }
  @media (prefers-reduced-motion: reduce) {
    .carousel-control-prev,
    .carousel-control-next {
      transition: none;
    }
  }
  .carousel-control-prev:hover, .carousel-control-prev:focus,
  .carousel-control-next:hover,
  .carousel-control-next:focus {
    color: #fff;
    text-decoration: none;
    outline: 0;
    opacity: 0.9;
  }
  .carousel-control-prev {
    left: 0;
  }
  .carousel-control-next {
    right: 0;
  }
  .carousel-control-prev-icon,
  .carousel-control-next-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: no-repeat 50% / 100% 100%;
  }
  .carousel-control-prev-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23444' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e");
  }
  .carousel-control-next-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23444' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e");
  }
  .carousel-indicators {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 15;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    padding-left: 0;
    margin-right: 15%;
    margin-left: 15%;
    list-style: none;
  }
  .carousel-indicators li {
    box-sizing: content-box;
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
    width: 30px;
    height: 3px;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    cursor: pointer;
    background-color: #fff;
    background-clip: padding-box;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    opacity: .5;
    transition: opacity 0.6s ease;
  }
  @media (prefers-reduced-motion: reduce) {
    .carousel-indicators li {
      transition: none;
    }
  }
  .carousel-indicators .active {
    opacity: 1;
  }
  .carousel-caption {
    position: absolute;
    right: 15%;
    bottom: 20px;
    left: 15%;
    z-index: 10;
    padding-top: 20px;
    padding-bottom: 20px;
    color: #fff;
    text-align: center;
  }
</style>

<script>
  import { BCarousel, BCarouselSlide } from 'bootstrap-vue'
  export default {
    props: {
      cpntId: {
        required: true,
        type: String
      },
      cpntBackground: {
        required: false,
        type: String,
        default: function () {
          return '#fefefe'
        }
      },
      cpntWidth: {
        required: false,
        type: Number,
        default: function () {
          return 400
        }
      },
      cpntNome: {
        required: false,
        type: String,
        default: function () {
          return ''
        }
      },
      cpntExplica: {
        type: Object,
        required: false
      },
      cpntHeight: {
        required: false,
        type: Number,
        default: function () {
          return 200
        }
      },
      cpntIndicadores: {
        required: false,
        type: Boolean,
        default: function () {
          return false
        }
      },
      cpntTempo: {
        required: false,
        type: Number,
        default: function () {
          return 9999999
        }
      },
      cpntSalvarPosteriormente: {
        required: false,
        type: Boolean,
        default: function () {
          return true
        }
      },
      cpntRefMod: {
        required: true,
        type: Number
      },
      cpntRefId: {
        required: true,
        type: Number
      }
    },
    components: {
      'b-carousel': BCarousel,
      'b-carousel-slide': BCarouselSlide,
      'vue-easy-lightbox': () => import('vue-easy-lightbox'),

      'RF-Status-2': () => import('@/components/rf-geral/status/RF-Status-2.vue'),
      'RF-Carousel-Editar': () => import('@/components/rf-geral/carousel/RF-Carousel-Editar.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        slide: 0,
        sliding: null,
        buttons: null,
        imagens: [],
        lightbox: '',
        cpntAnexar: null,
        mostrar: false
      }
    },
    mounted: function () {
      this.cpntCarouselIniciar()
    },
    destroyed: function () {
      this.$store.state.WEB_SOCKET_OBSERVADOR('ArmArquivo', 'cpnt-carousel', null)
    },
    methods: {
      cpntCarouselIniciar: function () {
        // CHAMA A FUNÇÃO PARA SETAR O STATUS
        this.cpntCarouselSetarStatusGeral('carregando')

        // ADICIONA O OBSERVADOR
        this.$store.state.WEB_SOCKET_OBSERVADOR('ArmArquivo', 'cpnt-carousel', (evento) => {
          for (var key in evento) {
            switch (this.cpntRefMod) {
              case 12:
                if ([ '', null, undefined ].indexOf(evento[key].id_pro_imagem) === -1 && evento[key].id_pro_imagem.toString() === this.cpntRefId.toString()) {
                  switch (evento[key].status) {
                    case '1':
                      // VERIFICA SE FOI RECEBIDO ALGUM LINK PARA DOWNLOAD
                      evento[key].src = [ '', null, undefined ].indexOf(evento[key].link_download) === -1 ? evento[key].link_download : './sem_imagem.png'
    
                      // ADICIONA A IMAGEM NO VETOR
                      this.imagens.push(evento[key])
                      break

                    default:
                      // REMOVE O ID SOLICITADO
                      this.imagens = this.imagens.filter(item => item.id !== evento[key].id)
                      break
                  }
                }
                break
            }
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }, 'usu')

        // INICIA OS BOTÕES
        this.buttons = {}

        // CHAMA A FUNÇÃO PARA BUSCAR OS ARQUIVOS
        this.cpntCarouselAnexarBuscarArquivos(() => {
          // CHAMA A FUNÇÃO PARA ANEXAR O ARQUIVO
          this.buttons.anexar = {
            status: '',
            id: this.cpntId + '--anexar',
            texto: 'Anexar',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: true,
            onClick: this.cpntCarouselAnexarArquivo
          }

          // CHAMA A FUNÇÃO PARA ANEXAR O ARQUIVO
          this.buttons.editar = {
            status: '',
            id: this.cpntId + '--editar',
            texto: 'Editar',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: true,
            editar: false,
            onClick: () => {
              // SETA O STATUS DA TELA
              this.buttons.editar.editar = !this.buttons.editar.editar

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }
          }

          // CHAMA A FUNÇÃO PARA SETAR O STATUS
          this.cpntCarouselSetarStatusGeral('')

          this.mostrar = true
          // // SETA O FLAG PRA MOSTRAR OS ARQUIVOS
          // setTimeout(() => { this.mostrar = true }, 500)
        })
      },
      cpntCarouselSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cpntCarouselSalvarArquivosPendentes: function (id, callback) {
        if (this.cpntAnexar === null) {
          callback()
        } else {
          this.cpntAnexar.armArquivoAnexarArquivoLer(null, true, id, callback)
        }
      },
      cpntCarouselAnexarArquivo: function () {
        if (this.cpntAnexar === null) {
          // SETA OS PARAMETROS PARA INICIAR
          var params = { tipo: 'ANEXAR_ARQUIVO', refMod: this.cpntRefMod, refId: this.cpntRefId }
  
          // VERIFICA SE É UMA FUNÇAO
          params.salvarPosteriormente = this.cpntSalvarPosteriormente === false ? null : this.cpntCarouselAdicionarArquivo
  
          // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
          this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
        } else {
          // MOSTRA DE ARMAZENAMENTO
          this.cpntAnexar.mostrar = true
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.cpntAnexar.time = new Date().getTime()
        }
      },
      cpntCarouselAdicionarArquivo: function (arquivos, cpntAnexar) {
        // SETA O PARAMETRO RECEBIDO
        if (this.cpntAnexar === null) {
          this.cpntAnexar = cpntAnexar
        }

        // TRATA OS ARQUIVOS RECEBIDOS
        for (var key in arquivos) {
          // SETA O SRC DO ARQUIVOS
          arquivos[key].src = arquivos[key].conteudo

          // ADICIONA O ARQUIVO NO VETOR
          this.imagens.push(arquivos[key])
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cpntCarouselCalcularTamanho: function (indexI, tipo) {
        // CARREGA OS VALORES
        var x = this.cpntWidth
        var y = this.cpntHeight
        switch (tipo) {
          case 'mini':
            x = (this.cpntWidth * 0.22)
            y = (this.cpntHeight * 0.22)
            break
        }

        // PEGA O ELEMENTO QUE DEVE SER ATUALIZADO
        var elemento = [ '', null, undefined ].indexOf(this.$refs[tipo][indexI]) === -1 ? this.$refs[tipo][indexI] : this.$refs[tipo]

        // CRIA A IAMGEM PARA PEGAR O TAMANHO REAL DELA
        var imagem = document.createElement('img')

        // SETA O LINK DA IMAGEM
        imagem.src =  elemento.src
      
        // PEGA OS TAMANHOS REAL DA IMAGEM
        var imageWidth = imagem.width
        var imageHeight = imagem.height
        
        // CALCULA OS TAMANHOS PROPORCIONAIS
        if (imageHeight > y) {
          imageWidth = imageWidth * (y / imageHeight)
          imageHeight = y

          if (imageWidth > x) {
            imageHeight = imageHeight * (x / imageWidth)
            imageWidth = x
          }
        } else if (imageWidth > x) {
          imageHeight = imageHeight * (x / imageWidth)
          imageWidth = x

          if (imageHeight > y) {
            imageWidth = imageWidth * (y / imageHeight)
            imageHeight = y
          }
        }
        
        // SETA OS TAMANHOS CALCULADOS
        elemento.style.width = imageWidth
        elemento.style.height = imageHeight
      },
      cpntCarouselAnexarBuscarArquivos: function (callback = null) {
        var self = this

        // INICIA O QUERYGET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, filename: null, ext: null, size_bytes_thumbnail: null, posicao: null }, order: {} }

        // VERIFICA O TIPO DE ARQUIVO QUE DEVE BUSCAR
        switch (self.cpntRefMod) {
          case 12:
            // SETA OS CAMPOS ADICIONAS QUE DEVE SER BUSCADO
            queryGet.field = Object.assign(queryGet.field, { id_pro_imagem: null })

            // SETA O WHERE QUE DEVE SER FEITO
            queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'id_pro_imagem', o: '=', v: self.cpntRefId } ] }
            break
        }

        // SETA A ORDENAÇÃO
        queryGet.order.posicao = 'asc'

        // FAZ A BUSCA NA API
        self.$store.state.comunicaAPI('/arm-arquivo/get/', 'GET', queryGet, function (apiSuccess) {
          // PEGA OS DADOS RECEBIDOS
          var vetor = apiSuccess.data

          // INICIA O VETOR QUE VAI RECEBER OS DADOS
          var thumbnailIds = []
          
          for (var key in vetor) {
            // VERIFICA SE TEM ICONE
            if ([ '', null, undefined ].indexOf(vetor[key].size_bytes_thumbnail) === -1 && Number(vetor[key].size_bytes_thumbnail) > 0) {
              thumbnailIds.push(vetor[key].id)
            }

            // INICIA A VARIAVEL QUE VAI RECEBER O ICONE
            vetor[key].src = ''
          }

          // ADICIONA OS ARQUIVOS RECEBIDOS
          self.imagens = self.imagens.concat(vetor)

          // CHAMA A FUNÇÃO PARA BUSCAR OS ICONES
          self.cpntCarouselBuscarThumbnail('link_download', thumbnailIds, function (registros) {
            for (var key in registros) {
              // PEGA O NUMERO DA LINHA
              var index = self.imagens.findIndex(item => item.id === registros[key].id)

              // VERIFICA SE FOI ENCONTADO O ICONE
              if (index !== -1) {
                // SETA O ICONE
                self.imagens[index].src = registros[key].link_download
              }
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          })

          // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
          if (callback !== null) {
            callback()
          }
        }, self.cpntCarouselSetarStatusGeral)
      },
      cpntCarouselBuscarThumbnail: function (tipo, ids, callback, qtde = 300, ini = null, fim = null, retornos = []) {
        var self = this

        // SETA OS DADOS QUE SERÁ BUSCADO
        if (ini === null && fim === null) {
          ini = 0
          fim = qtde
        } else if (ids.length > (ini + qtde)) {
          ini += qtde
          fim += qtde
        } else {
          ini = null
          fim = null
        }

        if (ini !== null && fim !== null) {
          // PEGA OS IDS QUE DEVE BUSCAR
          var busca = ids.slice(ini, fim)

          // INICIA O QUERYGET
          var queryGet = { lot: [] }
          
          // ADICIONA O VALOR AO VETOR
          for (var key in busca) {
            queryGet.lot.push({ id: busca[key], tipo: [ tipo ] })
          }

          // FAZ A BUSCA NA API
          self.$store.state.comunicaAPI('/arm-arquivo/arquivo/get/', 'GET', queryGet, function (apiSuccess) {
            // ADICIONA OS VALORES NO VETOR
            for (var index in apiSuccess.lot) {
              switch (apiSuccess.lot[index].code) {
                case '200':
                  retornos.push(apiSuccess.lot[index].data)
                  break

                default:
                  self.$store.state.msgWarn('API [' + apiSuccess.lot[index].code + ']: ' + apiSuccess.lot[index].message, 'danger')
                  break
              }
            }

            // FAZ A QUEBRA O VALOR RECEBIDO E CHAMA A FUNÇÃO PARA BUSCAR
            self.cpntCarouselBuscarThumbnail(tipo, ids, callback, qtde, ini, fim, retornos)
          }, self.cpntCarouselSetarStatusGeral)
        } else if (callback !== null) {
          callback(retornos)
        }
      },
      cpntCarouselMostrarLightbox: function (indexI) {
        // VERIFICA SE DEVE MOSTRAR OU NÃO O LIGHTBOX
        this.lightbox = indexI

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    }
  }
</script>